import React from "react";

const GeneralLayout = ({ children }) => {
  return (
    <>
      <div>
        <main>{children}</main>
      </div>
    </>
  );
};

export default GeneralLayout;
